import { EventTemplateModalSelectedStateRowProps } from "./event_template_page";

export function EventTemplateModalSelectedStateRow(
	props: EventTemplateModalSelectedStateRowProps
) {
	if ("childs" in props) {
		return (
			<>
				<div className="opacity-75">{props.label}</div>
				<div className="w-full">
					<div className="mx-1 w-full border-l border-white/25">
						<div className="-mx-1 w-full px-4">
							{props.childs.map((val, index) => (
								<EventTemplateModalSelectedStateRow
									key={index}
									{...val}
								/>
							))}
						</div>
					</div>
				</div>
			</>
		);
	}

	return (
		<div className="grid w-full grid-cols-12">
			<div className="col-span-6 opacity-75 sm:col-span-5">
				{props.label}
			</div>
			<div className="col-span-6 whitespace-nowrap sm:col-span-7">
				{props.value ? props.value : "None"}
			</div>
		</div>
	);
}
